module.exports = __webpack_public_path__ + "media/images/common/logo-b5163e5ec0f307cfcd5310396227ddae.webp";